import Api from "../config/Axios";

export const getList = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + token, UserId: parseInt(user_id)}};
  return Api.get(`api/web/order/cancellation-reasons`, {params:data, ...config});
};

export const getSingle = (token, user_id, id) => {
  const config = {headers: {Authorization: "Bearer " + token, UserId: parseInt(user_id)}};
  return Api.get(`api/web/order/cancellation-reasons/${id}`, config);
};

export const postAdd = (token, user_id, data, id) => {
  const config = {headers: {Authorization: "Bearer " + token, UserId: parseInt(user_id)}};
  return Api.post(`api/web/order/cancellation-reasons`, data, config);
};

export const patchEdit = (token, user_id, data, id) => {
  const config = {headers: {Authorization: "Bearer " + token, UserId: parseInt(user_id)}};
  return Api.patch(`api/web/order/cancellation-reasons-update/${id}`, data, config);
};

export const deleteRemove = (token, user_id, id) => {
  console.log(" ser deleteAction", id)
  const config = {headers: {Authorization: "Bearer " + token, UserId: parseInt(user_id)}};
  return Api.delete(`api/web/order/cancellation-reasons/${id}`, config);
};

